<template>
<NavBarWeb/>
<div class="sectionKoko">
  <div class="container" style="text-align: left">
  <div class="sectionHead">Terms and Conditions</div>

  <p><b>MERCHANT AGREEMENT</b></p>

    
<p dir="ltr">
    This Merchant Agreement (the “Agreement”) is entered into by and between
    Dinnovation (Private) Limited, a private limited company established under
    the laws of Sri Lanka, bearing company registration No. PV 00225927. having
    its office at No 14, Sri Baron Jayathilake Mawatha, Colombo 01 (hereinafter
    referred to as “the Company”); and the Merchant listed in “Merchant
    Registration Form” attached.
</p>
<p dir="ltr">
    The Company and the Seller shall sometimes individually be referred to as
    the “Party” and collectively as the “Parties”.
</p>
<p dir="ltr">
    THE PARTIES AGREE ON TERMS AND CONDITIONS AS FOLLOWS:
</p>
<ol>
    <li dir="ltr">
        <p dir="ltr">
            SERVICES
        </p>
    </li>
</ol>
<p dir="ltr">
    The Merchant desires to obtain certain services offered by the Company and
    access to and use the system developed by the Company for the
    implementation and administration of an online installment payment solution
    including subdomains, sites, mobile app, payment system, services and tools
    (“the Platform”) which will give the Merchant the ability to offer
    customers registered with the Company’s Platform (“Customers”) the option
    to purchase products and services offered for sale by the Merchant
    (“Products”), in installments from the Merchant’ store online or physical
    (“Merchant’s Store”) hereinafter referred to as “Services”. For the
    avoidance of doubt, the Company’s Platform does not constitute a lending or
    credit facility and the Company does not provide any credits to Merchants
    or Customers.
</p>
<ol start="2">
    <li dir="ltr">
        <p dir="ltr">
            COMMENCEMENT OF SERVICES
        </p>
    </li>
</ol>
<p dir="ltr">
    The Merchant agrees to submit a Merchant Application Form correctly and
    completely filled in together with supporting documents required by the
    Company on the date hereof for the Company’s consideration. The applicant
    shall be entitled to use the Services only upon obtaining the Company’s
    permission.
</p>
<ol start="3">
    <li dir="ltr">
        <p dir="ltr">
            MERCHANT’S ELIGIBILITY
        </p>
    </li>
</ol>
<ol>
    <li dir="ltr">
        <p dir="ltr">
            In order to be eligible to receive Services, the Merchant must;
        </p>
    </li>
    <ol>
        <li dir="ltr">
            <p dir="ltr">
                carry on a legitimate business in Sri Lanka
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                have a place of business in Sri Lanka
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                provide the contact details of an authorized representative who
                has the authority to make business decisions from time to time
                related to the Services
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                have a bank account of the Merchant where the Company can
                deposit the monies due and payable from the Company to the
                Merchant (Merchant’s Bank Account”)
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                completion of the know-your-customer process undertaken by the
                Company as part of Company’s due diligence to verify the
                business details, ownership structure, and general viability
                and other details of the Merchant “KYC Process” as set forth in
                Clause 4 hereof.
            </p>
        </li>
    </ol>
    <li dir="ltr">
        <p dir="ltr">
            The Company reserves the right to deny, suspend or terminate the
            provision of the Services to the Merchant in the event the Merchant
            fails to meet the eligibility requirements set out in Clause 3.1
            above at any point in time, and the Merchant shall have no right to
            appeal against such decision.
        </p>
    </li>
</ol>
<ol start="4">
    <li dir="ltr">
        <p dir="ltr">
            KYC PROCESS
        </p>
    </li>
    <ol>
        <li dir="ltr">
            <p dir="ltr">
                Upon signing of the Merchant Registration Form and this
                Agreement, the Merchant shall, as soon as possible and prior to
                the Merchant’s acceptance of any Orders, complete the KYC
                Process which entail;
            </p>
        </li>
        <ol>
            <li dir="ltr">
                <p dir="ltr">
                    the Merchant submitting relevant business information for
                    the Company’s review and acceptance;
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    any other step the Company may at its sole discretion
                    require from time to time.
                </p>
            </li>
        </ol>
        <li dir="ltr">
            <p dir="ltr">
                Notwithstanding the Clause 4.1.1 above, the Company may at its
                sole discretion initiate the KYC Process prior to the signing
                of the Merchant Registration Form and this Agreement.
            </p>
        </li>
    </ol>
    <li dir="ltr">
        <p dir="ltr">
            MERCHANT ACCOUNT
        </p>
    </li>
    <ol>
        <li dir="ltr">
            <p dir="ltr">
                The Company will create an operating account with the Company’s
                Platform (“Merchant Account”) in order for the Merchant to
                manage its operation with the Company, including but not
                limited to managing its Orders, Refunds, Reversals, and
                Settlements as morefully described herein below.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                The Merchant will be notified upon creation of the Merchant
                Account and will be required to set a password for the Merchant
                Account. The Merchant remains solely responsible for the safety
                of such a password.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                Where the Company has reasonable cause to suspect that the
                Merchant has been involved in any illegal act within the
                Platform and where devices, email accounts and/or phone numbers
                are being used to perform an order or create a Merchant Account
                and such devices, email addresses and/or phone numbers are
                reasonably suspected by us to be involved in connection with
                any illegal act within the Platform or otherwise we:
            </p>
        </li>
        <ol>
            <li dir="ltr">
                <p dir="ltr">
                    reserves the right to conduct investigations, with internal
                    and external third-parties, to determine the extent and
                    impact of the suspected conduct;
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    may seek your cooperation and assistance in dealing with
                    such activities;
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    may request immediate payment from you for all outstanding
                    payables to us;
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    reserves the right to suspend any Merchant Account
                    associated with you until such act is halted or restricted
                    to our satisfaction;
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    reserves the right to temporarily suspend or permanently
                    block you from using or participating Site or its network;
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    may, at its sole discretion, close any Merchant Account(s)
                    whether associated with the suspected illegal act or
                    otherwise; and
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    reserves the right to report such behavior to the relevant
                    authorities.
                </p>
            </li>
        </ol>
        <li dir="ltr">
            <p dir="ltr">
                The Company may close Merchant Account:
            </p>
        </li>
        <ol>
            <li dir="ltr">
                <p dir="ltr">
                    without Merchant’s consent or prior notice, if the Company
                    become aware that any Merchant Account associated with the
                    Merchant is being used by a third party or has been
                    compromised in any way whether as a result of your actions
                    or inactions or otherwise;
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    if the Company consider that the Merchant is using the
                    Platform and its services inappropriately, illegally, or in
                    any other way or for any other purpose other then what has
                    been expressly permitted under this Agreement;
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    if Merchant has not paid outstanding payables to the
                    Company and:
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    if the Merchant fails to meet the eligibility requirements
                    set out in Clause 3 hereof on an ongoing basis, the Company
                    may suspend, block, withdraw, close or otherwise render
                    inoperable the Merchant Account.
                </p>
            </li>
        </ol>
    </ol>
    <li dir="ltr">
        <p dir="ltr">
            MERCHANT EXPOSURE LIMIT
        </p>
    </li>
    <ol>
        <li dir="ltr">
            <p dir="ltr">
                The amount of financial exposure that the Merchant is allowed
                to accumulate in the Platform will be determined during the KYC
                Process as per Clause 4 herein above (“Merchant Exposure
                Limit”).
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                Where Orders placed within a certain period exceed the Merchant
                Exposure Limit, the Company reserves the right to suspend any
                further Orders being submitted in the Platform until the time
                period has lapsed and the Merchant Exposure Limit is refreshed.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                In the event the Orders are suspended due to the Merchant
                Exposure Limit being exceeded, the Company will;
            </p>
        </li>
        <ol>
            <li dir="ltr">
                <p dir="ltr">
                    Inform the designated contact person within 4 hours;
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    Review the order placement activity that resulted in the
                    Merchant Exposure Limit being exceeded; and
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    Work with the Merchant to resolve the limitations
                </p>
            </li>
        </ol>
    </ol>
</ol>
<br/>
<ol start="7">
    <li dir="ltr">
        <p dir="ltr">
            VALIDATION, RISK AND ASSESSMENT
        </p>
    </li>
</ol>
<p dir="ltr">
    The Company will conduct the following verifications for each Order;
</p>
<ol>
    <li dir="ltr">
        <p dir="ltr">
            where the Company is satisfied of the eligibility of both the
            Merchant and the Customer at the time of the Order, Order will be
            captured in the Platform upon real-time checks and validations;
        </p>
    </li>
    <ol>
        <li dir="ltr">
            <p dir="ltr">
                on the Merchant’s eligibility, Merchant’s Exposure Limit, the
                Order value, product risk which will be determined based on
                metrics adopted by the Company from time to time to a Product
                or a category of Product and overall risk in general for all
                transaction;
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                on Customer’s credentials, devices, relationship with other
                Customer/s and historical data;
            </p>
        </li>
    </ol>
    <li dir="ltr">
        <p dir="ltr">
            The Company reserve the right to reject or cancel any order where;
        </p>
    </li>
    <ol>
        <li dir="ltr">
            <p dir="ltr">
                The Company has a reason to suspect or become aware that the
                Merchant has breached the terms of this Agreement;
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                The Merchant fails to satisfy validations, checks and
                assessments as per Clause 7.1.1;
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                The Company suspects or become aware of a suspicious activity
                within the Platform by which may contravene applicable laws and
                regulations;
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                The Company suspects that the Merchant’s systems have been
                compromised;
            </p>
        </li>
    </ol>
</ol>
<ol start="8">
    <li dir="ltr">
        <p dir="ltr">
            PLACEMENT OF ORDERS
        </p>
    </li>
    <ol>
        <li dir="ltr">
            <p dir="ltr">
                Upon placement of an Order by a Customer, the Company shall
                advice the Merchant of the outcome of such Order request:
            </p>
        </li>
        <ol>
            <li dir="ltr">
                <p dir="ltr">
                    Where the Order is unsuccessful, the Company will inform
                    the Customer and the Merchant with a reason for
                    non-acceptance and may provide the Customer a further
                    number of attempts to try as may be determined by the
                    Company from time to time; and
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    Where the Order request is successful, the Company will;
                </p>
            </li>
            <ol>
                <li dir="ltr">
                    <p dir="ltr">
                        Inform the Merchant and provide records of same; and
                    </p>
                </li>
                <li dir="ltr">
                    <p dir="ltr">
                        Pay the order value to the Merchant in terms of Payment
                        and Merchant’s Fee Clause
                    </p>
                </li>
            </ol>
        </ol>
    </ol>
    <li dir="ltr">
        <p dir="ltr">
            MERCHANT’S OBLIGATIONS
        </p>
    </li>
</ol>
<p dir="ltr">
    The Merchant shall:
</p>
<ol>
    <li dir="ltr">
        <p dir="ltr">
            Use the Platform in accordance with the operating procedure
            determined by the Company from time to time;
        </p>
    </li>
    <li dir="ltr">
        <p dir="ltr">
            Comply with data protection standards as applicable and / or
            determined by the Company
        </p>
    </li>
    <li dir="ltr">
        <p dir="ltr">
            Keep the contact and other information updated
        </p>
    </li>
    <li dir="ltr">
        <p dir="ltr">
            Immediately inform of;
        </p>
    </li>
    <ol>
        <li dir="ltr">
            <p dir="ltr">
                The change of business address
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                Any change to the Merchant’s ownership, management and
                directorship
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                Change to the type of products/ services offered by the
                Merchant
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                Change of name of the Merchant
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                Any change to the Merchant’s financial status including any
                insolvency, liquidation etc;
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                Any other material change relation to the Merchant business and
                activities
            </p>
        </li>
    </ol>
    <li dir="ltr">
        <p dir="ltr">
            Use and display the promotional materials and/or logo as approved
            by the Company prominent exterior and interior locations as
            appropriate within the physical store/s and on each page of the
            e-commerce site, where applicable
        </p>
    </li>
    <li dir="ltr">
        <p dir="ltr">
            Be solely responsible for fulfilling all Customer orders, Refunds
            and Reversals and the quality of the Products including but not
            limited to any and all warranties
        </p>
    </li>
    <li dir="ltr">
        <p dir="ltr">
            Treat Orders placed by Customers using the Platform in the same
            manner as those placed via any other payment methods
        </p>
    </li>
    <li dir="ltr">
        <p dir="ltr">
            Not charge any additional cost, charges of fee from the Customer or
            add to the Customer’ bill when the Customer opt to pay the Merchant
            using the Company’s Services
        </p>
    </li>
    <li dir="ltr">
        <p dir="ltr">
            Be solely responsible to inform the Customers of the ability or
            inability to perform the Order within expected timeframe
        </p>
    </li>
    <li dir="ltr">
        <p dir="ltr">
            At the time of each order provide all information in a manner and
            format as determined by the Company from time to time enabling the
            Company to process the Order and perform its obligation hereunder
        </p>
    </li>
    <li dir="ltr">
        <p dir="ltr">
            Be solely responsible for any matters relating to tax or additional
            fee arising from its use of the Platform including but not limited
            to;
        </p>
    </li>
    <ol>
        <li dir="ltr">
            <p dir="ltr">
                Tax determinations
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                Any fee to be paid to government or regulatory authority
            </p>
        </li>
    </ol>
    <li dir="ltr">
        <p dir="ltr">
            Be responsible for its Merchant Account its use and ongoing
            security and shall not permit any unauthorized person or other
            entity to access the Merchant’s account
        </p>
    </li>
    <li dir="ltr">
        <p dir="ltr">
            Allow access to conduct audits and reviews at the Merchant’ Store
            as may be reasonably required by the Company or by third party
            payment providers for the performance of this agreement or as may
            be required by law
        </p>
    </li>
    <li dir="ltr">
        <p dir="ltr">
            To corporate with the Company in the event of any investigation
            performed by the Company, any third party or legal authority in
            relation to any order, payment or matter related to the Merchant’s
            Account
        </p>
    </li>
</ol>
<ol start="10">
    <li dir="ltr">
        <p dir="ltr">
            THE COMPANY’S OBLIGATIONS
        </p>
    </li>
    <ol>
        <li dir="ltr">
            <p dir="ltr">
                The Company shall use commercially reasonable endeavors to
                support the modules and APIs that Marchant may use to connect
                to the Platform.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                Notwithstanding the Clause 10.1 above the Company reserves the
                right to modify the modules, APIs and the payment system at its
                sole discretion and will use its best endeavors to notify the
                Merchant of such modifications in order to allow the Merchant
                sufficient time to;
            </p>
        </li>
        <ol>
            <li dir="ltr">
                <p dir="ltr">
                    Alter the Merchant’s systems to support the modifications
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    Implement alternative modules or APIs that will provide the
                    capability to process Orders on the Platform; or
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    Terminate its use of the Platform
                </p>
            </li>
        </ol>
    </ol>
    <li dir="ltr">
        <p dir="ltr">
            PAYMENTS AND MERCHANT’S FEE
        </p>
    </li>
    <ol>
        <li dir="ltr">
            <p dir="ltr">
                The Company is entitled to the service fee for performance of
                obligations hereunder according to the rate and payment method
                specified in the Merchant Application Form (“Merchant’s Fee”).
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                During the period of this Agreement, the Company reserves the
                right to amend the rate of Merchant’s Fees and any other fees
                as applicable by giving at least thirty (30) days advance
                notice to the Merchant and such notice shall be deemed an
                integral part of this agreement.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                The Company shall transfer the payment being the value of the
                transactions made by Customers on the Merchant’ Store for
                Products to be transferred to the Merchant by the Company,
                less, subject to its right of set-off under this agreement to
                the Merchant’s Bank Account (“Settlement”).
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                The payments will be made to the Merchant via online transfer
                or such other manner opted by the Company at its discretion on
                a two weekly basis to the Merchant’s Bank Account.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                The Company shall within time intervals be determined at the
                Company’s sole discretion, issue statements consolidating and
                detailing all accrued and unpaid Settlement amounts as at the
                date of such statement (“Payment Statements”).
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                The Merchant agrees that the Company shall not be liable for
                any failure to make payments arising due to incomplete or
                inaccurate information provided by the Merchant with regards to
                its Bank Account.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                For the avoidance of doubt, any delay in the payment of any
                Installment (s) by any Customer shall not affect the Company’s
                payment obligation to the Merchant.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                Where the Merchant requests a Reversal or Refund for a Customer
                in terms of Clause 12 hereof and the Products have not been
                delivered to the Customer, the Merchant may still incur charges
                and fees in using the Company’s Payment System.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                Where there are any moneys owed by the Merchant to the Company
                for transaction occurring in the Company’s Payment System which
                cannot be set off against the moneys to be paid by the Company
                to the Merchant, the Merchant agrees to pay the Company at such
                time and in such manner that the Company may in its sole
                discretion require.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                The Company shall be entitled to deduct or withhold from
                payments to be made to the Merchant under this agreement any
                duties, taxes or other amounts required to be deducted or
                withheld under any law applicable in Sri Lanka and to remit the
                same to the taxing authority of any jurisdiction relevant to
                the transaction.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                The Merchant shall be responsible for payment of all customs
                duties, sales tax, excise tax, value-added tax and any other
                duties, excess, fees or charges of whatsoever nature which may
                be imposed by governing authorities of any jurisdiction
                applicable in connection with sale or supply of its Products
                and their purchase by Customers. It is clarified that the
                Merchant shall be solely responsible for the payment of any
                sales tax on the sale of the Products to the Customer through
                the Site and the Company shall have no liability in this
                regard.
            </p>
        </li>
    </ol>
    <li dir="ltr">
        <p dir="ltr">
            DISPUTES, REVERSALS AND REFUNDS
        </p>
    </li>
    <ol>
        <li dir="ltr">
            <p dir="ltr">
                Disputes
            </p>
        </li>
    </ol>
</ol>
<p dir="ltr">
    In the event of any dispute between the Merchant and a Customer;
</p>
<ol>
    <li dir="ltr">
        <p dir="ltr">
            the Merchant acknowledges that it is solely responsible for dealing
            with all disputes, complaints, concerns and other issues from any
            Customer in relation to any Order placed with the Merchant;
        </p>
    </li>
    <li dir="ltr">
        <p dir="ltr">
            the Merchant shall release the Company (and its agents and
            employees) from claims, demands, and damages (actual and
            consequential) of every kind and nature, known and unknown,
            suspected and unsuspected, disclosed and undisclosed, arising out
            of or in any way connected with such disputes.
        </p>
    </li>
    <li dir="ltr">
        <p dir="ltr">
            where the Merchant has not resolved any dispute to the satisfaction
            of the Customer and the Customer raises the dispute with the
            Company, the Merchant agrees to use best endeavors to review and
            resolve the dispute;
        </p>
    </li>
    <li dir="ltr">
        <p dir="ltr">
            Notwithstanding an ongoing dispute, the Merchant remains liable to
            the Company for any outstanding debts related to the Order in
            dispute.
        </p>
    </li>
</ol>
<ol start="2">
    <li dir="ltr">
        <p dir="ltr">
            Reversals
        </p>
    </li>
</ol>
<p dir="ltr">
    In the event of a reversal:
</p>
<ol>
    <li dir="ltr">
        <p dir="ltr">
            the Merchant shall notify the Company that it is unable to fulfil
            the Customer’s order captured in the Platform as a result of a
            successful transaction between a Customer and the Merchant using
            the Company’s payment System to effect the payment (“Customer’s
            Order”) and lodge a request (“Reversal Request”) with the Company
            within four (04) hours of the Customer’s Order being captured in
            the Company’s Payment System or, if the Reversal Request is not
            lodged within this stipulated time, the Merchant may lodge a
            request for a full refund;
        </p>
    </li>
    <li dir="ltr">
        <p dir="ltr">
            The Company will reverse the value of Customer Order (“Revered
            Order”) in full and the Merchant will not be required to issue the
            Products in the Reversed Order to the Customer.
        </p>
    </li>
    <li dir="ltr">
        <p dir="ltr">
            The Reversal will be reflected in the Merchant’ Account.
        </p>
    </li>
</ol>
<ol start="3">
    <li dir="ltr">
        <p dir="ltr">
            Refunds
        </p>
    </li>
</ol>
<p dir="ltr">
    In the event of a Refund:
</p>
<ol>
    <li dir="ltr">
        <p dir="ltr">
            Refunds of the Products shall be subject to Merchant’s applicable
            return and refund policy and any other statutory requirements as
            applicable in relation to such Products and the Company shall not
            bear any responsibility in respect thereof;
        </p>
    </li>
    <li dir="ltr">
        <p dir="ltr">
            Merchant shall lodge a request within sixty (60) days of the Order
            being captured in the Company’s Platform (“Refund Request”) and any
            Refund request beyond this time must be expressly agreed between
            the Merchant and the Customer and the Merchant shall notify the
            Company within 24 hours of such agreement to refund.
        </p>
    </li>
    <li dir="ltr">
        <p dir="ltr">
            Where a refund (full or partial) is agreed between the Merchant and
            the Customer, the Merchant shall request to return the disputed
            Product(s) (where applicable) to the Merchant. Upon return of such
            Products, Merchant shall acknowledge same and notify the Company in
            writing to process the refund, upon which;
        </p>
    </li>
</ol>
<ol>
    <li dir="ltr">
        <p dir="ltr">
            The Company will refund the amount already paid by the Customer in
            full or the agreed amount as the case may be; and
        </p>
    </li>
    <li dir="ltr">
        <p dir="ltr">
            The Merchant Account will be updated to reflect the full Refund and
            the adjusted balance.
        </p>
    </li>
    <li dir="ltr">
        <p dir="ltr">
            Upon receipt of a Refund Request, the Company shall within a
            reasonable time, process such request and pay such refund amount to
            the Company’s payment processor to be processed in line with
            payment processor’s practices. In this regard, the Merchant
            acknowledges that any refund amount due to be refunded into the
            Customer or the Merchant is subject to handling methods outside the
            Company’s control and the Merchant shall not hold the Company
            liable for any delays.
        </p>
    </li>
    <li dir="ltr">
        <p dir="ltr">
            The Merchant acknowledges that the company may impose Merchant Fees
            and / or Merchant Processing Fees on any Refund or Reversals and
            the same will be reflected in the Payment Statement
        </p>
    </li>
</ol>
<br/>
<ol start="13">
    <li dir="ltr">
        <p dir="ltr">
            WARRANTIES AND REPRESENTATIONS
        </p>
    </li>
    <ol>
        <li dir="ltr">
            <p dir="ltr">
                The Merchant warrants and represents to the Company that:
            </p>
        </li>
        <ol>
            <li dir="ltr">
                <p dir="ltr">
                    It is a Company duly incorporated, validly existing, and in
                    good standing under the laws of Sri Lanka.
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    It is competent to enter into this Agreement and its entry
                    into this Agreement and the performance thereof have been
                    duly authorized by all necessary corporate action and
                    constitutes a valid and binding agreement of the Merchant,
                    enforceable against the Merchant in accordance with the
                    terms thereof.
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    All information, including but not limited to all
                    information furnished to the Company is accurate and
                    up-to-date.
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    All formal consents, waivers, approvals, authorizations,
                    exemptions, registrations, licenses or declarations of or
                    by or filing with, any authority or contracting party which
                    are required to be made or obtained by the Merchant to
                    conduct its business generally and the performance of the
                    obligations hereunder, have been made or duly obtained.
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    The entry, delivery and performance of this Agreement by
                    the Merchant will not violate or conflict in any material
                    respect with any law applicable in Sri Lanka.
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    It will at all times meet the eligibility requirements
                    specified in Clause 3.
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    It will, at all times comply with data security standards
                    and such other industry standards related to use of the
                    Company's Platform that applies and / or as may be
                    reasonably requested
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    by the Company from time to time.
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    It has control over the Products and shall ensure that the
                    quality of the Product is maintained throughout the
                    Agreement.
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    by the Company from time to time.
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    It has control over the Products and shall ensure that the
                    quality of the Product is maintained throughout the
                    Agreement.
                </p>
            </li>
        </ol>
        <li dir="ltr">
            <p dir="ltr">
                The Company may at any point require the Merchant to provide
                relevant business information for the purpose of this
                Agreement, and the Merchant shall provide the same to the
                Company within fifteen (15) Business Days (days on which banks
                generally are open for business in Sri Lanka, excluding
                Saturday and Sunday) of such requests being made.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                It is the Company's policy to prohibit and actively pursue the
                prevention of money laundering and any activity that
                facilitates money laundering or the financing or of terrorist
                or criminal activities. We are committed to anti-money
                laundering compliance in accordance with applicable law and
                require Merchant to adhere to these standards in preventing the
                use of the Company’s Platform and its services for money
                laundering purposes.
            </p>
        </li>
    </ol>
    <li dir="ltr">
        <p dir="ltr">
            INTELLECTUAL PROPERTY
        </p>
    </li>
    <ol>
        <li dir="ltr">
            <p dir="ltr">
                The Merchant shall not be entitled to use any intellectual
                property belonging to the Company without Company’ prior
                approval in writing.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                Both Parties shall not make any negative, denigrating, or
                defamatory statement(s)/comment(s) about each other, the brand
                name, or the Company’s Platform, or otherwise engage in any
                conduct or action that might tarnish the image or reputation of
                the Company or Merchants on the platform or otherwise tarnish
                or dilute any Company’s or Merchants’ trade mark, service
                marks, trade name and/or goodwill associated with such trade,
                service marks or trade name as may be owned or used by either
                Party.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                The Company may refer to the Merchant as a user of the
                Company’s Platform in marketing, sales or similar material
                however subject to Merchants brand guidelines as may be
                provided to the Company by the Merchant. Upon termination of
                this Agreement the Company shall as soon as practicable and
                within a reasonable time, remove all respective logotypes of
                the Merchant and the Merchant’s brand specifically related to
                the Company’s Platform.
            </p>
        </li>
    </ol>
    <li dir="ltr">
        <p dir="ltr">
            OUR SOFTWARE
        </p>
    </li>
    <ol>
        <li dir="ltr">
            <p dir="ltr">
                The Company’s software includes any software (including any
                updates or upgrades to the software and any related
                documentation) that we make available to the Merchant from time
                to time for Merchant’s use in connection with the Company’s
                Platform (the "Software").
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                The Merchant shall use the software solely for purposes of
                enabling the Merchant to use and enjoy services as permitted by
                these Terms and Conditions and any related applicable terms as
                available on the Platform. The Merchant may not incorporate any
                portion of the Software into your own programs or compile any
                portion of it in combination with Merchant’s own programs,
                transfer it for use with another service, or sell, rent, lease,
                lend, loan, distribute or sub-license the Software or otherwise
                assign any rights to the Software in whole or in part. The
                Merchant shall not use the Software for any illegal purpose.
                The Company may cease providing services and /or terminate
                Merchant’s right to use the Software at any time. Merchant’s
                rights to use the Software will automatically terminate without
                notice from the Company if you fail to comply with any of the
                Terms and Conditions herein or across the Platform. Additional
                third-party terms contained within the Platform or distributed
                as such that are specifically identified in related
                documentation may apply and will govern the use of such
                software in the event of a conflict with this Agreement. All
                software used in any of Company’s services is Company’s
                property and/or our affiliates or its software suppliers and
                protected by the laws of Sri Lanka including but not limited to
                any other applicable copyright laws.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                When the Merchant uses the Platform, the Merchant may also be
                using the services of one or more third parties, such as a
                wireless carrier or a mobile platform provider. Merchant’s use
                of these third party services may be subject to separate
                policies, terms of use, and fees of these third parties.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                All Intellectual Property Rights (where “Intellectual Property
                Rights” shall mean any and all patents, trademarks, domain
                names, website designs and layouts, service marks, trade names,
                registered designs, copyrights, database rights, design rights,
                service marks, business names, logos, trade secrets, technical
                and commercial know-how, whether registered or otherwise, and
                all and any other similar type of proprietary rights, whether
                it can be registered or not) in and related to the Platform,
                its composite engineering, know-how and processes shall be and
                shall remain the exclusive property of the Company.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                The Merchant shall not, and you will not encourage, assist or
                authorize any other person to copy, modify, reverse engineer,
                decompile or disassemble, or otherwise tamper with our software
                whether in whole or in part, or create any derivative works
                from or of the Software.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                In order to keep the Software up-to-date, the Company may offer
                automatic or manual updates at any time and without notice to
                you.
            </p>
        </li>
    </ol>
    <li dir="ltr">
        <p dir="ltr">
            CONFIDENTIALITY
        </p>
    </li>
    <ol>
        <li dir="ltr">
            <p dir="ltr">
                All Customer information and data, designs, drawings,
                specifications, communications, whether written, oral,
                electronic, visual, graphic, photographic, observational, or
                otherwise, and documents supplied, revealed or disclosed in any
                form or manner to the Merchant by the Company, or produced or
                created by the Merchant for the Company hereunder are the
                intellectual property of, and confidential to the Company and
                shall be used solely by the Merchant for purposes of this
                Agreement. All such information shall be treated and protected
                by the Merchant as strictly confidential and shall not be
                disclosed to any third party without the prior written consent
                of the Company and shall be disclosed within the Merchant’s
                organization only on a need-to-know basis.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                Both Parties may require their respective employees and other
                personnel involved in the performance of this Agreement to
                execute an individual confidentiality agreement prior to any
                disclosure.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                Both Parties shall immediately return to each other any
                information provided, either upon demand, or upon termination
                of this agreement, including all copies made by either Party.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                Both Parties shall not publicize, disclose, or discuss the
                existence, content, or scope, whether generalities or details,
                of this Agreement or make any reference to each other, the
                business of either to any third party by any means, and through
                any medium (including but not limited to advertising, web site
                references, photographs, articles, press releases or
                interviews, speeches or programs) without obtaining prior
                written consent.
            </p>
        </li>
    </ol>
    <li dir="ltr">
        <p dir="ltr">
            INDEMNIFICATION
        </p>
    </li>
    <ol>
        <li dir="ltr">
            <p dir="ltr">
                Each Party agrees to indemnify, defend and hold the other Party
                harmless and keep it indemnified from and against all direct
                losses, damages, penalties, costs, expenses and charges imposed
                on or incurred by the other Party as a result of any claims,
                demands, litigations, lawsuits and/or legal proceedings by a
                third party arising out of any act(s), omission(s),
                noncompliance or breach by the defaulting Party, including its
                officers or employees, of this Agreement or of directives,
                rules, regulations, instructions, or orders of any statutory,
                regulatory or municipal authority or any other applicable laws
                or third-party agreements, in the running, operation,
                maintenance pursuant to this Agreement.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                In addition to the above, if the Merchant is in breach of its
                warranties, representations, covenants and obligations as
                detailed under this Agreement, then the Merchant understands
                and agrees that the Company shall be entitled to receive, from
                Merchant, indemnification and/or compensation for any costs,
                expenses, losses or damages, penalty/fine, etc. caused to the
                Company thereby arising from, alleged to arise from, or in any
                way associated with:
            </p>
        </li>
        <ol>
            <li dir="ltr">
                <p dir="ltr">
                    any defect in Products sold to any Customer;
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    any claim made by any Customer on the basis of any contract
                    between the Customer and the Merchant;
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    any violation of any law committed by the Merchant,
                    including any failure by the Merchant to pay any required
                    tax on the import, manufacture, production, sale, supply,
                    distribution or delivery of a Product;
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    any negligence or fault of whatever nature of the Merchant
                    or its affiliates, and any director, officer, employee,
                    contractor, or agent; or
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    Imposition of fine, penalty and/or claims, against the
                    Company, by any competent authority, including but not
                    limited to, Customer Affairs Authority as well as any
                    competent court of law
                </p>
            </li>
        </ol>
        <li dir="ltr">
            <p dir="ltr">
                The Merchant shall indemnify and hold harmless the Company its
                affiliates and their respective officers, directors,
                shareholders, agents and employees, from any claim or demand,
                or actions including reasonable attorney's fees, made by any
                third party or penalty imposed due to or arising out of your
                breach of the terms and conditions of this Agreement or any
                document incorporated by reference, or your violation of any
                law, rules, regulations or the rights of a third party.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                The Merchant hereby expressly release the Company and/or its
                affiliates and/or any of its officers, directors, shareholders
                and representatives from any cost, damage, liability or other
                consequence of any of the actions/inactions of the Customers or
                other service providers and specifically waiver any claims or
                demands that you may have in this behalf under any statute,
                contract or otherwise.
            </p>
        </li>
    </ol>
    <li dir="ltr">
        <p dir="ltr">
            LIMITATION OF LIABILITY
        </p>
    </li>
    <ol>
        <li dir="ltr">
            <p dir="ltr">
                The Platform, including all content, software, functions,
                materials and information made available on or provided in
                connection with the Merchant’s access to and use of the
                Platform, are provided “as-is.” The Merchant acknowledges and
                confirms that it will access and use the Platform at its own
                risk. To the fullest extent permissible by law, the Company
                disclaims: (I) any representations or warranties regarding this
                Agreement, the contracts or the transactions contemplated by
                this Agreement, including any implied warranties of
                Merchantability, fitness for a particular purpose or
                non-infringement; (ii) implied warranties arising out of course
                of dealing, course of performance or usage of trade; and (iii)
                any obligation, liability, right, claim or remedy in tort,
                whether or not arising from the Company’ negligence. The
                Company does not warrant that the functions contained in the
                Platform will meet the Merchant’s requirements or be available,
                timely, secure uninterrupted or error free, and the Company
                will not be liable for any service interruptions, including but
                not limited to system failures or other interruptions that may
                affect the receipt, processing, acceptance, completion or
                settlement of any contracts or transactions.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                The Merchant expressly acknowledges that the Company is not a
                party to any contracts and / or sale and purchase of Products
                between the Merchant and Customers via the Platform. If a
                dispute arises, the Customer and Merchant shall release the
                Company (and its agents and employees) from claims, demands,
                and damages (actual and consequential) of every kind and
                nature, known and unknown, suspected and unsuspected, disclosed
                and undisclosed, arising out of or in any way connected with
                such disputes.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                The Company will not be liable (whether in contract, warranty,
                tort (including negligence, product liability or other theory)
                or otherwise) to the Merchant or any other person for cost of
                cover, recovery or renouncement of any investment made by the
                Merchant in connection with this Agreement, or for any loss of
                profit, revenue, business, or data or punitive or consequential
                damages arising out of or relating to this agreement, even if
                the Company has been advised of the possibility of those costs
                or damages. Further, Company’ aggregate liability arising out
                of or in connection with this Agreement, or the transactions
                contemplated will not exceed at any time the total Merchant
                Fees earned during the prior three-month period paid by the
                Merchant to the Company.
            </p>
        </li>
    </ol>
    <li dir="ltr">
        <p dir="ltr">
            FORCE MAJEURE
        </p>
    </li>
    <ol>
        <li dir="ltr">
            <p dir="ltr">
                The Company shall not be liable to the Merchant or be deemed to
                be in breach of this Agreement by reason of any delay in
                performing or any failure to perform any of the Company’
                obligations if the delay or failure was due to any cause beyond
                the Company’s reasonable control. Without prejudice to the
                generality of the foregoing the following shall be regarded as
                causes beyond the Company’s reasonable control:
            </p>
        </li>
        <ol>
            <li dir="ltr">
                <p dir="ltr">
                    Act of God, pandemic, epidemic, explosion, flood, tempest,
                    fire or accident war or threat of war, sabotage,
                    insurrection, civil disturbance or requisition;
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    Acts, restrictions, regulations, bye-laws, prohibitions or
                    measures of any kind on the part of any governmental,
                    parliamentary or local authority;
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    interruption of traffic, strikes lock-outs or other
                    industrial actions or trade disputes (whether involving
                    employees of the Company or of a third party);
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    interruption of production or operation, difficulties in
                    obtaining raw materials labor, fuel, parts or machinery;
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    power failure or breakdown in machinery.
                </p>
            </li>
        </ol>
        <li dir="ltr">
            <p dir="ltr">
                The Company may, at its option, fully or partially suspend
                delivery/performance while such circumstances continue and the
                Company shall not be liable for any loss or damage suffered by
                the Merchant as a result of such suspension, including but not
                limited to from the Merchant’s failure to fulfill any
                transaction with a Customer.
            </p>
        </li>
    </ol>
    <li dir="ltr">
        <p dir="ltr">
            DURATION &amp; TERMINATION
        </p>
    </li>
    <ol>
        <li dir="ltr">
            <p dir="ltr">
                This Agreement remains valid for one year from the Commencement
                Date as set forth in the Merchant Registration Form and shall
                automatically renew for successive one (1) year periods each
                (each, a “Renewal Term” and together with the Initial Term, the
                “Term”) unless otherwise terminated by the Parties in terms of
                the provisions hereof.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                Either Party may terminate this Agreement by giving sixty (60)
                Days’ written notice to the other.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                On or at any time after the occurrence of any of the events of
                default in Clause 15.4 below, the Company shall, in addition to
                any rights or remedies it may have in law, in equity, be
                entitled to terminate this Agreement with immediate effect by
                written notice to the Merchant. The following shall constitute
                events of default:
            </p>
        </li>
        <ol>
            <li dir="ltr">
                <p dir="ltr">
                    the Merchant being in breach of any warranty or
                    representation under this agreement or any Contract;
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    the Merchant being in breach of any obligation under this
                    agreement failing to remedy the same on or before seven (7)
                    Business Days (days on which banks generally are open for
                    business in Sri Lanka excluding Saturday and Sunday) from
                    receipt of a written notice from the Company of such
                    breach;
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    the Merchant passing a resolution for its winding up or a
                    court of competent jurisdiction making an order for the
                    Company’s winding up or dissolution;
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    the Merchant making of an administration order in relation
                    to the Merchant or the appointment of a receiver over or an
                    encumbrance taking possession of or selling any of the
                    Merchant’s assets;
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    the Merchant making an arrangement or settlement with its
                    creditors generally or applying to a court of competent
                    jurisdiction for protection from its creditors;
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    the Merchant ceasing or threatening to cease to carry on
                    business; or
                </p>
            </li>
            <li dir="ltr">
                <p dir="ltr">
                    the Company reasonably apprehends that any of the events
                    mentioned above is about to occur in relation to the
                    Merchant and notifies the Merchant accordingly.
                </p>
            </li>
        </ol>
        <li dir="ltr">
            <p dir="ltr">
                The Merchant shall be obliged to perform all contracts already
                entered into with Customers.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                The Parties will settle all outstanding liabilities immediately
                upon termination of this agreement.
            </p>
        </li>
    </ol>
    <li dir="ltr">
        <p dir="ltr">
            ASSIGNMENT
        </p>
    </li>
    <ol>
        <li dir="ltr">
            <p dir="ltr">
                The Merchant may not assign this Agreement or any part hereof,
                or any money due hereunder, without the prior written consent
                of the Company. If consent is granted, any such assignment by
                the Merchant shall not increase or alter the Company’s
                obligations nor diminish the rights of the Company, nor relieve
                the Merchant of any of its obligations under this Agreement.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                The Company reserves the right to assign this agreement, in
                whole or in part, to any party, including its affiliates with a
                reasonable prior written notice to the Merchant.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                The Merchant shall give the Company prompt written notice of
                any change in its ownership or organization.
            </p>
        </li>
    </ol>
    <li dir="ltr">
        <p dir="ltr">
            NOTICES
        </p>
    </li>
    <ol>
        <li dir="ltr">
            <p dir="ltr">
                All notices required or authorised by this Agreement are to be
                in writing in the English language and are to be delivered by
                either party to the other by hand or email or by registered
                post to such address as the parties may inform each other from
                time to time in accordance with this section. Notices delivered
                by hand will be deemed given upon hand delivery
            </p>
        </li>
    </ol>
    <li dir="ltr">
        <p dir="ltr">
            RELATIONSHIP OF THE PARTIES
        </p>
    </li>
    <ol>
        <li dir="ltr">
            <p dir="ltr">
                Nothing in this Agreement will create any partnership, joint
                venture, agency, franchise, sales representative or employment
                relationship between the Parties or impose any liability on the
                Company in relation to the Merchant beyond that specifically
                expressed in this Agreement.
            </p>
        </li>
    </ol>
    <li dir="ltr">
        <p dir="ltr">
            MODIFICATIONS
        </p>
    </li>
    <ol>
        <li dir="ltr">
            <p dir="ltr">
                The Merchant acknowledges and agrees that the Company may at
                its sole discretion modify, amend or change any of the terms
                and conditions of this agreement and /or implement Platform
                policies and guidelines from time to time and notifications of
                such changes will be sent to the Merchant in writing. The
                Merchant will then have fourteen (14) days to accept any and
                all modifications or communicate disagreement to the Company in
                writing. If there is no response from the Merchant it will
                count as an agreement on the Merchant’s part.
            </p>
        </li>
    </ol>
    <li dir="ltr">
        <p dir="ltr">
            MISCELLANEOUS
        </p>
    </li>
    <ol>
        <li dir="ltr">
            <p dir="ltr">
                Any typographical clerical or other error or omission in any
                acceptance, invoice or other document on the part of the
                Company shall be subject to correction without any liability on
                the part of the Company.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                No waiver by the Company of any breach of this Agreement by the
                Merchant shall be considered as a waiver of any subsequent
                breach of the same or any other provision.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                If any provision of this Agreement is held by any competent
                authority to be invalid or unenforceable in whole or in part
                the validity of the other provisions of this agreement and the
                remainder of the provision in question shall not be affected
                thereby.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                No person who is not a party to this Agreement (including any
                employee, officer, agent, representative or sub-contractor of
                either party) shall have any right to enforce any terms of this
                Agreement which expressly or by implication confers a benefit
                on that person without the express prior agreement in writing
                of the Parties.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                The Company shall be entitled to commence legal proceedings for
                the purposes of protecting its confidential information or any
                exclusivity rights, as contained in this Agreement, by means of
                injunctive or other equitable relief.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                This agreement shall be governed by the laws of Sri Lanka . In
                the event the Parties have any disagreement or dispute relating
                to or arising out of this Agreement the Parties shall endeavour
                to resolve such dispute amicably and in good faith. In the
                event the dispute cannot be resolved through mutual
                discussions, the dispute or differences shall be referred to
                the appropriate Court of Law or, both parties agreeing,
                referred to arbitration under the rules of the Institute for
                Commercial Law and Practice in accordance with its Rules and
                then prevailing laws.
            </p>
        </li>
        <li dir="ltr">
            <p dir="ltr">
                This Agreement may be executed in one or more counterparts and
                by exchange of electronically signed counterparts transmitted
                by pdf format or exchange by hard-copy, each of which shall be
                deemed an original and all of which, when taken together, shall
                constitute one and the same original instrument.
            </p>
        </li>
    </ol>
</ol>



</div></div>
<FooterWeb/>

</template>

<script>
import NavBarWeb from "@/components/NavBarWeb";
import FooterWeb from "@/components/FooterWeb";
export default {
  name: "Merchant Terms",
  components: {FooterWeb, NavBarWeb}
}
</script>

<style scoped>
.sectionKoko {
  padding-top: 60px;
  padding-bottom: 60px;
}

.sectionHead {
  font-family: Raleway;
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  /* line-height: 42px; */

  color: #393939;

}

.sectionBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  padding-top: 10px;
  padding-bottom: 10px;
  color: #393939;

  opacity: 0.8;

}
</style>